import { StyleSheet } from 'react-native';
const mtdSpacing = {
    // 水平间距
    mtdHSpacingS: 4,
    mtdHSpacingM: 8,
    mtdHSpacingL: 12,
    mtdHSpacingXL: 16,
    mtdHSpacingX2L: 20,
    // 垂直间距
    mtdVSpacingXS: 2,
    mtdVSpacingS: 4,
    mtdVSpacingM: 8,
    mtdVSpacingL: 10,
    mtdVSpacingXL: 12,
    mtdVSpacingX2L: 16,
    mtdVSpacingX3L: 18,
    mtdVSpacingX4L: 20
};
const mtdBorder = {
    mtdBorderWidth: StyleSheet.hairlineWidth,
    mtdBorderColor: '#F5F5F5',
    mtdBorderColorDark: '#e5e5e5',
    mtdBorderColorDarker: '#d5d5d5'
};
export const space = Object.assign(Object.assign({}, mtdSpacing), mtdBorder);
